import PropTypes from 'prop-types';
import { createStore, compose, applyMiddleware } from "redux";
import { routerMiddleware } from 'connected-react-router'
import thunkMiddleware from 'redux-thunk';
import rootReducer from './reducers';
import history from '../routes/history';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import { purgeStoredState } from 'redux-persist';
import { createLogger } from 'redux-logger';

import { config } from '../Constants';

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['router']
}

export default function configureStore(preloadedState){
    const middlewares = [thunkMiddleware, routerMiddleware(history)];

    if (config.reduxLogger)
        middlewares.push(createLogger());

    const middlewareEnhancer = applyMiddleware(...middlewares);
    const persistedReducer = persistReducer(persistConfig, rootReducer(history));
    const enhancers = [middlewareEnhancer];
    const composedEnhancers = compose(...enhancers);
    const store = createStore(persistedReducer, preloadedState, composedEnhancers);
    const persistor = persistStore(store);
    return { history, store, persistor };
}

configureStore.propTypes = {
    preloadedState: PropTypes.object
}

export function purge() {
    purgeStoredState(persistConfig);
}
